import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { getDesignLibraryElementNode } from '../BKJSelect/utils/getDesignLibraryElementNode.js';
import { Portal } from '../Portal/Portal.js';
import { BKJTooltipArrow, BKJTooltipArrowWrapper } from './BKJTooltipWrapper.styled.js';
export const BKJTooltip = ({ placement, triggerRef, children, }) => {
    const [tooltipRef, setTooltipRef] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const [targetElement, setTargetElement] = useState(getDesignLibraryElementNode('tooltip-root'));
    const { styles, attributes } = usePopper(triggerRef.current, tooltipRef, {
        placement,
        modifiers: [
            {
                name: 'arrow',
                options: {
                    element: arrowElement,
                },
            },
        ],
    });
    useEffect(() => {
        if (!targetElement) {
            const element = document.createElement('div');
            element.setAttribute('id', 'tooltip-root');
            document.body.prepend(element);
            setTargetElement(element);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(Fragment, { children: targetElement && (_jsx(Portal, { targetElement: targetElement, children: _jsxs(BKJTooltipArrowWrapper, { ref: setTooltipRef, style: styles['popper'], ...attributes['popper'], children: [_jsx(BKJTooltipArrow, { className: "BKJTooltipArrow", ref: setArrowElement, style: styles['arrow'] }), children] }) })) }));
};
//# sourceMappingURL=BKJTooltip.js.map